import React from 'react'
import PropTypes from 'prop-types'

import { SvgIcon } from '../svg-icon'

const propTypes = {
    className: PropTypes.string,
    height: PropTypes.number,
    width: PropTypes.number
}

const defaultProps = {
    height: 22,
    width: 22
}

/**
 * Renders a collapsible double arrow for expand
 * @see SvgIcon for propTypes
 *
 * @example
 * <DoubleChevronIcon width={12} />
 * <DoubleChevronIcon height={12} />
 */

const DoubleChevronIcon = props => {
    return (
        <SvgIcon viewBoxSize={96} {...props}>
            <g>
                <path d="M72,48l-5.4-5.4L48,60.6L29.4,42L24,48l24,24L72,48z" />
                <path d="M72,30l-5.4-5.4L48,42.6L29.4,24L24,30l24,24L72,30z" />
            </g>
        </SvgIcon>
    )
}

DoubleChevronIcon.defaultProps = defaultProps
DoubleChevronIcon.propTypes = propTypes

export { DoubleChevronIcon }
